/** `generation_config` app setting: the Gemini model + Vertex location that write project documents. */
export interface GenerationConfig {
  model: string;
  location: string;
}

export const GENERATION_CONFIG_KEY = "generation_config";

export function readGenerationConfig(settings: { key: string; value: unknown }[] | undefined): GenerationConfig {
  const value = settings?.find((s) => s.key === GENERATION_CONFIG_KEY)?.value as Partial<GenerationConfig> | undefined;
  return { model: value?.model ?? "", location: value?.location ?? "" };
}

/** nara-core answers 422 `unpriced_model` for a model it cannot charge; the callable carries it in the message. */
export function generationSaveError(err: unknown): "unpriced" | "error" {
  return err instanceof Error && err.message.includes("unpriced_model") ? "unpriced" : "error";
}
